// Comparação normalizada (minúsculas + espaços colapsados) para não depender da
// capitalização exata que o backend usa (ex.: "Agendamento de assinatura").
const TIPOS_ENCERRADOS_PELA_RECEPCAO = [
  "agendamento de visita",
  "agendamento de assinatura",
];

const normalizar = (texto: string | null | undefined): string =>
  (texto ?? "").trim().replace(/\s+/g, " ").toLowerCase();

/**
 * Regra de quem encerra a tarefa.
 *
 * Tarefas dos tipos "Agendamento de Visita" e "Agendamento de Assinatura" nas
 * regionais SP/RJ (não-Sul) só podem ser encerradas pela recepcionista ao
 * cadastrar a visita no PDV. Logo, o corretor NÃO deve ver a opção de concluir.
 *
 * No Sul, quem encerra é o próprio corretor, então a opção permanece.
 * Demais tipos de tarefa não têm restrição.
 *
 * O backend aplica a validação definitiva; aqui apenas escondemos a opção.
 */
export const podeCorretorConcluirTarefa = (
  nomeTipoTarefa: string | null | undefined,
  isSul: boolean
): boolean => {
  if (isSul) return true;
  return !TIPOS_ENCERRADOS_PELA_RECEPCAO.includes(normalizar(nomeTipoTarefa));
};
